import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { CheckCircle2, Mail, ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";

const WorkbookDanke = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Bestellung erhalten | FACHSPRECHPARTNER Workbook</title>
        <meta name="description" content="Vielen Dank für Ihre Bestellung des FACHSPRECHPARTNER OT-Security Workbooks. So geht es weiter." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://fachsprechpartner.de/workbook/danke" />
        <meta property="og:title" content="Bestellung erhalten | FACHSPRECHPARTNER Workbook" />
        <meta property="og:description" content="Vielen Dank für Ihre Bestellung des FACHSPRECHPARTNER OT-Security Workbooks." />
        <meta property="og:url" content="https://fachsprechpartner.de/workbook/danke" />
      </Helmet>
      <Navbar />
      <section className="pt-32 pb-24 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-secondary/10 text-secondary flex items-center justify-center mb-6">
            <CheckCircle2 size={36} strokeWidth={2.25} />
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Vielen Dank für Ihre Bestellung
          </h1>
          <p className="text-muted-foreground leading-relaxed mb-8">
            Ich habe Ihre Bestellung des FACHSPRECHPARTNER Workbooks erhalten. Eine Bestätigung
            geht parallel per E-Mail an Sie raus. Inkludiert ist auch das 60 Min. Online Assessment
            Sparring, das wir nach Erhalt des Workbooks terminieren.
          </p>

          <div className="text-left bg-card border border-border rounded-md p-6 mb-8">
            <h2 className="font-display font-semibold text-lg text-foreground mb-3">
              So geht es weiter
            </h2>
            <ol className="space-y-3 text-sm text-foreground">
              <li className="flex gap-3">
                <span className="font-bold text-secondary">1.</span>
                <span>Sie erhalten in Kürze die Rechnung per E-Mail.</span>
              </li>
              <li className="flex gap-3">
                <span className="font-bold text-secondary">2.</span>
                <span>Nach Zahlungseingang sende ich Ihnen das Workbook als PDF zu und wir vereinbaren das 60 Min. Online Assessment Sparring.</span>
              </li>
              <li className="flex gap-3">
                <span className="font-bold text-secondary">3.</span>
                <span>Bei Rückfragen antworten Sie einfach auf die Bestätigungsmail.</span>
              </li>
            </ol>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <a
              href="mailto:info@fachsprechpartner.de"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-secondary text-secondary-foreground font-semibold text-sm"
            >
              <Mail size={16} /> info@fachsprechpartner.de
            </a>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-border text-foreground font-semibold text-sm hover:bg-section-alt transition-colors"
            >
              <ArrowLeft size={16} /> Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WorkbookDanke;